import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { Link } from "@argo/ui-elements";
import { typography, colors, size, breakpoints } from "@argo/principles";
import { GLOBALNAV_KBB_BASE_URL } from '../../mykbb/utils/constants';
var CopyrightContainer = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    color: ", ";\n    align-items: center;\n    justify-content: flex-start;\n    line-height: 24px;\n    margin-top: ", ";\n\n    > span {\n        margin: 0 0 ", "px 0;\n\n        @media (min-width: ", "px) {\n            margin: 0 ", "px ", "px 0;\n        }\n    }\n\n    @media (min-width: ", "px) {\n        justify-content: center;\n    }\n"])), typography.types.bodySmall, colors.primary.white, function (props) {
  return props.enableOneTrust ? '16px' : '0';
}, size.sm, breakpoints.md, size.xs, size.xs, breakpoints.md);
var CopyrightLinks = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: wrap;\n\n    > a {\n        white-space: nowrap;\n        padding: 12px 0;\n        margin: 0 0 ", "px 0;\n    }\n\n    @media (min-width: ", "px) {\n        text-align: center;\n        justify-content: center;\n    }\n"])), size.xs, breakpoints.md);
var Divider = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin: 12px ", "px;\n"])), size.xs);
var NoneLink = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    margin: 12px 0;\n"])));
var Copyright = function Copyright(_ref) {
  var links = _ref.links,
    triggerAnalytics = _ref.triggerAnalytics,
    enableOneTrust = _ref.enableOneTrust;
  var currentYear = useMemo(function () {
    return new Date().getFullYear();
  }, [new Date()]);
  return React.createElement(CopyrightContainer, {
    enableOneTrust: enableOneTrust
  }, React.createElement("span", null, "\xA9 1995-", currentYear, " Kelley Blue Book Co.\xAE, Inc. All rights reserved."), React.createElement(CopyrightLinks, null, links && links.map(function (link, i) {
    return [link.url && link.url.length > 1 ? React.createElement(Link, {
      key: i,
      "data-automation": link.omnitureTag,
      "data-partner": link.partnerLink,
      "data-tag-id": "copyrightLinks".concat(i),
      onClick: triggerAnalytics && triggerAnalytics({
        googleTag: link === null || link === void 0 ? void 0 : link.googleTag,
        pixallTag: link === null || link === void 0 ? void 0 : link.pixallTag
      }),
      rel: (link === null || link === void 0 ? void 0 : link.rel) || null,
      href: "".concat(GLOBALNAV_KBB_BASE_URL).concat(link.url),
      type: 'unstyled',
      dangerouslySetInnerHTML: {
        __html: link.name
      }
    }) : React.createElement(NoneLink, {
      key: i,
      "data-tag-id": "copyrightLinks".concat(i)
    }, link.name), i !== links.length - 1 && React.createElement(Divider, {
      key: "a".concat(i)
    }, "|")];
  }), enableOneTrust && React.createElement(React.Fragment, null, React.createElement(Divider, null, "|"), React.createElement(Link, {
    "data-automation": 'managecookies_footer',
    onClick: function onClick(e) {
      e.preventDefault();
      if (typeof window !== "undefined" && window.OneTrust) {
        var _OneTrust;
        triggerAnalytics && triggerAnalytics({
          googleTag: 'text-link::manage-cookies',
          pixallTag: 'text-link::manage-cookies'
        })();
        (_OneTrust = OneTrust) === null || _OneTrust === void 0 || _OneTrust.ToggleInfoDisplay();
      }
    },
    "data-tag-id": "copyrightLinks7",
    href: '#',
    type: 'unstyled'
  }, "Manage Cookies"))));
};
Copyright.displayName = 'Copyright';
export default Copyright;